import en from '@/locales/en.json';
import es from '@/locales/es.json';

export type Language = 'en' | 'es';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; nativeLabel: string }[] = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
];

const translations: Record<Language, typeof en> = { en, es };

export function getTranslations(language: Language): typeof en {
  return translations[language] ?? translations.en;
}

/**
 * Detect the user's preferred language from the browser. * Falls back to'en' if the browser language is not supported.
 */
export function detectBrowserLanguage(): Language {
  if (typeof window === 'undefined') return 'en';
  const browserLang = navigator.language?.toLowerCase() ?? '';
  if (browserLang.startsWith('es')) return 'es';
  return 'en';
}

/**
 * Persist the chosen language to localStorage.
 */
export function saveLanguagePreference(lang: Language): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem('noticopa_language', lang);
  } catch {
    // ignore
  }
}

/**
 * Load the persisted language from localStorage, or detect from browser.
 */
export function loadLanguagePreference(): Language {
  if (typeof window === 'undefined') return 'en';
  try {
    const stored = localStorage.getItem('noticopa_language') as Language | null;
    if (stored && SUPPORTED_LANGUAGES.some((l) => l.code === stored)) return stored;
  } catch {
    // ignore
  }
  return detectBrowserLanguage();
}
